import { rootApi } from '../rootApi';

export const accountingReportApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getCariReportDetail: builder.query({
            query: (params) => ({
                url: 'v1/AccoutingReport/cari-report-detail',
                method: 'GET',
                params
            }),
            transformResponse: (response) => ({
                data: response.data || [],
                count: response.count || 0
            }),
            providesTags: ['AccountingReport']
        }),

        exportCariReportDetail: builder.query({
            query: (params) => ({
                url: 'v1/AccoutingReport/cari-report-detail-export',
                method: 'GET',
                params
            }),
            transformResponse: (response) => response.data
        }),

        getCariReportDetailCustomers: builder.query({
            query: (params) => ({
                url: 'v1/AccoutingReport/cari-report-detail-customers',
                method: 'GET',
                params: {
                    SearchText: params?.SearchText || '',
                    RowCount: params?.RowCount || 50
                }
            }),
            transformResponse: (resp) => resp?.data ?? []
        })
    })
});

export const {
    useGetCariReportDetailQuery,
    useLazyGetCariReportDetailQuery,
    useLazyExportCariReportDetailQuery,
    useGetCariReportDetailCustomersQuery
} = accountingReportApi;
